module.exports = {
  HOST: 'https://fcm.googleapis.com/fcm/send',
  NOTIFICATION_HOST: `https://ap.russeluno.golf/notification`,
};
